import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import ModalVideo from '@app/components/UI/ModalVideo/ModalVideo';
import {TEXT_LINK, ICON_LINK} from '@app/components/Pages/Resources/FamilyResources/FRUtils';
import {ContentEntity, ContentTopic} from '@app/objects/ContentTopic';
import {rest} from '@app/components/Api';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import {EmailShare, LinkedinShare, FacebookShare, TwitterShare} from '@app/components/LocalCommon/ShareButtons/ShareButtons';

const FRVideos = ({searchQuery}) => {
	const [contentVideosList, setContentVideosList] = React.useState<List<ContentEntity>>();
	const [modalVisible, setModalVisible] = React.useState(false);
	const [videoSrc, setVideoSrc] = React.useState('');
	const [videoIndex, setVideoIndex] = React.useState(0);
	const [offsetContent, setOffsetContent] = React.useState<number>(0);
	const [currentCategory, setCurrentCategory] = React.useState<ContentTopic>();
	const [isLoaded, setIsLoaded] = React.useState<boolean>(false);

	React.useEffect(() => {
		rest.get<List<ContentEntity>>(`v2/contentTopics/videos/content${searchQuery ? `?text=${searchQuery}` : ''}`)
			.then((res) => {
				setContentVideosList(res);
				setIsLoaded(true);
			});
	}, [searchQuery]);

	React.useEffect(() => {
		rest.get<List<ContentEntity>>(`v2/contentTopics/videos/content?offset=${offsetContent}`)
			.then((res) => {
				offsetContent > 0 && setContentVideosList((prev) => {

					if (prev?.list) {
						return {
							...res,
							list: [...prev.list, ...res.list]
						};
					}

					return res;
				});
			});
	}, [offsetContent]);

	const increaseOffsetContent = (count) => {
		setOffsetContent(offsetContent + count);
	};

	const onSetIssue = (category) => {
		setCurrentCategory(category);
		setOffsetContent(0);
	};

	const formatShareVideo = (videoUrl: string) => {
		if (videoUrl.indexOf('youtube.com') >= 0) {
			return videoUrl.replace('embed/', 'watch?v=');
		}

		return videoUrl;
	};

	return (
		<>
			<div className="blog-page__content">
				{!isLoaded ? <div className="faq-block__dummy">Woof! Looks like we're still loading a few things.</div> :
					contentVideosList && contentVideosList.list.length ?
						contentVideosList.list.map((item, index) => (
							<article key={index} className={`article article-video-${index}`}>
						<div className="article__info">
							<h6 className="article__caption">{item.title}</h6>
							<p className="article__text">{item.smallText}</p>
							<div className="article__addition">
								<span
									onClick={() => {
										setModalVisible(true);
										setVideoSrc(item.url);
										setVideoIndex(index);
									}}
									className="article__more btn-text">
										{TEXT_LINK[item.contentType]} <img className="arrow-icon" src={ICON_LINK[item.contentType]} alt="Arrow"/>
								</span>
								<div className="share-icons">
									<p>Share This Video</p>
									<FacebookShare url={formatShareVideo(item.url)} />
									<LinkedinShare url={formatShareVideo(item.url)} />
									<TwitterShare url={formatShareVideo(item.url)} />
									<EmailShare url={formatShareVideo(item.url)} />
								</div>
							</div>
						</div>
						<div className="article__photo" style={{ backgroundImage: `url(${item.avatar})` }} />
					</article>
						)) : <div className="faq-block__dummy">Woof! We were not able to find a match. Please try another search.</div>
				}

				{contentVideosList && contentVideosList.count > contentVideosList.list.length &&
				<div className="text-center">
					<button className="btn btn-lg btn-secondary blog-page__load-more" onClick={() => {
						increaseOffsetContent(10);
					}}>
						Load more
					</button>
				</div>
				}
			</div>

			<ModalVideo
				modalVisible={modalVisible}
				setModalVisible={setModalVisible}
				videoSrc={videoSrc}
				getContainer={`.article-video-${videoIndex}`}
			/>
		</>
	);
};

export default withSeo(FRVideos, state => state.videosPage, 'videosPage', 'videos');